<div class='hvac-create-account-header'>
    <button [ngClass]=" {'hide':  title === 'hide' }" (click)="logoClickFunction()" class="hvac-create-account-header-logo-link">
        <utc-svg class="hvac-create-account-header-logo" src="assets/images/hvac-partners.svg"></utc-svg>
        <span class="hvac-accessible-text">{{ 'BRAND' | translate }}</span>
    </button>
    <button *ngIf="!hideCancelButton" [disabled]="cancelButtonDisabled" hvacButton="secondary" (click)="cancelClickFunction()"  class='hvac-create-account-header-cancel-link' [innerHTML]="cancelButtonText | safe: 'html'"></button>
</div>
